/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { select } from 'redux-saga/effects';
import { getGoogleSuggestedAddress } from './GoogleAddressSearch-Selector';

export function* verifyAddressWithGoogleSuggestion(recipientAddress) {
    const address = {
        ...recipientAddress,
        address1: recipientAddress?.address1 || '',
        address2: recipientAddress?.address2 || '',
        city: recipientAddress?.city || '',
        country: recipientAddress?.country || '',
        state: recipientAddress?.state || '',
        zipCode: recipientAddress?.zipCode || '',
    };

    const googleSuggestedAddress = yield select(getGoogleSuggestedAddress);

    const addressMatched = googleSuggestedAddress.filter((suggestedAddress) => {
        if (
            address.address1?.toLowerCase() === suggestedAddress?.addressLine1?.toLowerCase()
            && address.address2?.toLowerCase() === suggestedAddress?.addressLine2?.toLowerCase()
            && address.city?.toLowerCase() === suggestedAddress?.city?.toLowerCase()
            && address.country?.toLowerCase() === suggestedAddress?.country?.toLowerCase()
            && address.state?.toLowerCase() === suggestedAddress?.state?.toLowerCase()
            && address.zipCode?.toLowerCase() === suggestedAddress?.zipcode?.toLowerCase()
        ) {
            return true;
        }

        return false;
    });

    if (addressMatched.length > 0) {
        address.isAddressVerified = 'V';
    }

    return address;
}

export default {};
